module.exports = __webpack_public_path__ + "img/site-setbakcs.92093c3e.svg";